<template>
  <div id="app">
    <Header v-if="showHeader"></Header>
    <transition name="fade" v-if="loading">
      <div class="loading">
        <Loading type="spinner" color="#06CCBF" vertical size="42px">{{ $t('empty.loading') }}</Loading>
      </div>
    </transition>
    <router-view v-else />
  </div>
</template>

<script>
import { Loading } from 'vant';
import { getUrlParam } from '@/utils/util.js';
import Header from '@/components/header.vue';
import { Notify } from 'vant';
export default {
  components: { Loading, Header },
  computed: {
    loading() {
      return !this.$store.state.auth.status;
    },
    id() {
      return this.$route.params.id;
    },
    pathName() {
      return this.$route.name;
    },
    showHeader() {
      return this.$route.meta.header !== false;
    },
  },
  methods: {
    initData() {
      this.$store.dispatch('getInfo', this.id).then(res => {
        if (!res) {
          this.$router.push('/');
        }
      });
    },
    initUserInfo() {
      let userInfo = sessionStorage.getItem('userInfo');
      if (userInfo) {
        userInfo = JSON.parse(userInfo);
        this.$store.commit('userUpdate', userInfo);
      }
    },
    initOpenid() {
      if (sessionStorage.getItem('openid') && sessionStorage.getItem('openid') != 'undefined') {
        return false;
      }
      const code = getUrlParam('code') || ''; // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
      // if (code) {
      //   this.$store.commit('openIdUpdate', code);
      //   sessionStorage.setItem('openId', code);
      // }
      // console.log(code);
      const local = window.location.href;
      const config = process.env.NODE_ENV === 'development' ? window.config.dev : window.config.prod;
      if (code) {
        this.$store
          .dispatch('getOpenId', code)
          .then(res => {
            if (!res) {
              // window.location.href =
              //   'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
              //   config.APPID +
              //   '&redirect_uri=' +
              //   encodeURIComponent(local) +
              //   '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
              Notify({
                type: 'error',
                message: this.$t('home.error.tips'),
              });
            }
          })
          .catch(e => {
            Notify({
              type: 'error',
              message: this.$t('home.error.tips'),
            });
          });
      } else {
        // https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx7723ff21ef3974e5&redirect_uri=http%3A%2F%2Fbaidu.com&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect
        window.location.href =
          'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
          config.APPID +
          '&redirect_uri=' +
          encodeURIComponent(local) +
          '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
      }
    },
  },
  // watch: {
  //   $route: "initData"
  // },
  created() {
    this.initUserInfo();
  },
  mounted() {
    this.initData();
    this.initOpenid();
  },
};
</script>

<style lang="less" scoped>
.loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 750px;
  height: 750px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
